import type { TPolygonCoords } from './types';

export const arrayCoordsToObject = (coords: TPolygonCoords): { x: number; y: number }[] => {
  return coords.map(([x, y]) => ({ x, y }));
};

export const objectCoordsToArray = (coords: { x: number; y: number }[]): TPolygonCoords => {
  return coords.map(({ x, y }) => ([x, y]));
};
